<template>
  <section class="section subtle" id="register">
    <div class="wrap">
      <div class="section-head">
        <div>
          <div class="eyebrow-line">Inscripción · 20 mayo → 20 septiembre 2026</div>
          <h2>RESERVA TU DORSAL.</h2>
        </div>
        <p class="intro-text">
          Plazas limitadas a <strong>300 parejas</strong>. Cierre el 20 de septiembre o cuando se agoten.
          La inscripción se gestiona en <strong>elitechip.net</strong>.
        </p>
      </div>

      <div class="tiers">
        <div class="tier featured">
          <div class="tier-top-row">
            <span>Early bird</span>
            <span class="early-badge">Primeras 150 parejas</span>
          </div>
          <div class="tier-name">
            50 €<span class="per-atleta">/ atleta</span>
          </div>
          <ul>
            <li>Inscripción por pareja · 100 €</li>
            <li>Welcome Pack + camiseta técnica</li>
            <li>Cronometraje por chip</li>
            <li>Avituallamiento y obsequio finisher</li>
            <li>Participación en sorteos post-competición</li>
            <li>Descuento en food trucks de la Plaza</li>
          </ul>
          <a class="btn btn-dark btn-hard" :href="REGISTRATION_URL" target="_blank" rel="noopener">
            Inscríbete · 100 € pareja →
          </a>
        </div>

        <div class="tier">
          <div class="tier-label">Tarifa estándar</div>
          <div class="tier-name">
            60 €<span class="per-atleta">/ atleta</span>
          </div>
          <ul>
            <li>A partir de la pareja 151</li>
            <li>Inscripción por pareja · 120 €</li>
            <li>Welcome Pack + camiseta técnica</li>
            <li>Cronometraje por chip</li>
            <li>Avituallamiento y obsequio finisher</li>
            <li>Descuento en food trucks de la Plaza</li>
          </ul>
          <a class="btn btn-outline" :href="REGISTRATION_URL" target="_blank" rel="noopener">Inscríbete · 120 € pareja</a>
        </div>
      </div>

      <div class="fine-print">
        <Info :size="16" class="fine-icon" />
        <div>
          <strong>Chip de cronometraje + 2,50 €</strong> · no incluido en la inscripción.
          Bajas con devolución del 75 % hasta el 1 de septiembre.
          Cambios de pareja permitidos hasta el 1 de septiembre.
          Edad mínima: 18 años. Inscripciones en
          <a :href="REGISTRATION_URL" target="_blank" rel="noopener">
            elitechip.net
          </a>.
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { Info } from 'lucide-vue-next'
import { REGISTRATION_URL } from '@/registration'
</script>

<style scoped>
.intro-text {
  max-width: 400px;
  color: var(--fg-2);
  font-size: 17px;
  margin: 0;
  line-height: 1.55;
}
.tier-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
}
.early-badge {
  background: var(--hir-black);
  color: var(--hir-orange);
  padding: 4px 10px;
  border-radius: 2px;
}
.per-atleta {
  font-family: var(--font-body);
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
  margin-left: 8px;
  opacity: 0.7;
}
.tier-label {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--fg-2);
}
.fine-icon {
  flex: 0 0 auto;
  margin-top: 2px;
  color: var(--hir-orange);
}
</style>
